import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { store } from "../lib/util";

export function FridgeBox() {
  const nav = useNavigate();
  const [val, setVal] = useState(() => store.get("fridge", ""));
  const [err, setErr] = useState("");
  const submit = e => {
    e.preventDefault();
    if (!val.replace(/[,;\s]/g, "")) { setErr("Skriv mindst én ingrediens"); return; }
    store.set("fridge", val);
    nav(`/koeleskabet/?i=${encodeURIComponent(val)}`);
  };
  return (
    <div className="fr-home" data-testid="home-fridge-box">
      <div><span className="fr-label">Køleskabet</span><h2>Hvad har du i køleskabet?</h2>
        <p>Skriv dine råvarer, så finder vi billig aftensmad, du kan lave med det, du har. Mangler vi en idé, laver vores AI et forslag.</p></div>
      <div>
        <form onSubmit={submit} role="search">
          <label className="vh" htmlFor="home-fridge-input">Dine ingredienser</label>
          <input id="home-fridge-input" placeholder="fx kylling, ris, løg" value={val} autoComplete="off"
            onChange={e => { setVal(e.target.value); setErr(""); }} data-testid="home-fridge-input" />
          <button className="btn" type="submit" data-testid="home-fridge-submit">Find aftensmad</button>
        </form>
        {err && <p className="fr-msg" role="alert" data-testid="home-fridge-error">{err}</p>}
      </div>
    </div>
  );
}
